import * as React from "react"

const HeadLightBulb = (props) => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.05621 0.5C10.5872 0.5 13.4345 3.20417 13.6124 6.605L15.4107 8.92417C15.6355 9.20833 15.4107 9.66667 15.0173 9.66667H13.6124V12.4167C13.6124 13.4342 12.7789 14.25 11.7392 14.25H10.8026V17H4.24641V12.7008C2.02666 11.6742 0.5 9.48333 0.5 6.91667C0.5 3.37833 3.4222 0.5 7.05621 0.5ZM6.11961 10.5833H7.99281V9.66667H6.11961V10.5833ZM4.62105 6.45833C4.8705 6.87053 5.22564 7.2118 5.65131 7.44833V8.75H8.46112V7.44833C9.80046 6.6875 10.2688 5.01 9.49138 3.70833C8.714 2.40667 6.99065 1.93 5.65131 2.68167C4.31197 3.43333 3.84367 5.12917 4.62105 6.45833Z"
			fill="#F18226"
		/>
	</svg>
)

export default HeadLightBulb
